<template>
  <div id="data-list-list-view" class="data-list-container">
    <div v-if="initProgress" class="w-100 mt-5 mb-5">
      <vs-progress indeterminate color="primary"></vs-progress>
    </div>

    <vs-prompt title="Exportar a Excel" class="export-options" @cancle="clearFields" @accept="exportToExcel"
               accept-text="Exportar" cancel-text="Cancelar" @close="clearFields" :active.sync="activePrompt">
      <vs-input v-model="fileName" placeholder="Ingresa el nombre del archivo..." class="w-full"/>
      <v-select v-model="selectedFormat" :options="formats" class="my-4"/>
      <div class="flex">
        <span class="mr-4">Auto ajustar columna:</span>
        <vs-switch v-model="cellAutoWidth">Auto ajustar columna</vs-switch>
      </div>
    </vs-prompt>

    <vx-card v-if="filter" ref="filterCard" title="Filtros" class="user-list-filters mb-8" collapse-action
             refresh-content-action @refresh="resetFilters">
      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Filtrar por categoría</label>
          <v-select label="name" :options="categories" :clearable="false"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="categoryFilter" class="mb-4 md:mb-0"/>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Filtrar por stock</label>
          <v-select :options="stocksOptions" :clearable="false"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="stockFilter" class="mb-4 md:mb-0"/>
        </div>
      </div>
    </vx-card>

    <new :list-for-related-products="listForRelatedProducts"
         :colors="colors"
         :categories="categories"
         :productsAll="productsAll"
         :isSidebarActive="newSidebar"
         @closeSidebar="toggleNewSidebar"
         @add="addDataSideBar"
         :data="sidebarData"/>
    <update :list-for-related-products="listForRelatedProducts"
            :colors="colors"
            :categories="categories"
            :productsAll="productsAll" :isSidebarActive="updateSidebar"
            @closeSidebar="toggleUpdateSidebar"
            @update="updateDataSideBar"
            :data="sidebarData"/>
    <sizes :isSidebarActive="sizeSidebar"
           @closeSidebar="toggleSizeSidebar"
           :data="sidebarData"/>

    <vs-table v-model="selected" ref="table" pagination :max-items="itemsPerPage" search
              :data="list">
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center data-list-btn-container">
          <!-- Action - dropnow -->
          <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer mr-4">
            <div
              class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full">
              <span class="mr-2">Acciones</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item @click="editData(selected)">
                <span class="flex items-center">
                  <feather-icon icon="EditIcon" svgClasses="h-4 w-4" class="mr-2"/>
                  <span>Editar</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item @click="filterData">
                <span class="flex items-center">
                  <feather-icon icon="FilterIcon" svgClasses="h-4 w-4" class="mr-2"/>
                  <span>Filtrar</span>
                </span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="activePrompt = true">
                <span class="flex items-center">
                  <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2"/>
                  <span>Exportar</span>
                </span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="exportToExcelFB">
                <span class="flex items-center">
                  <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2"/>
                  <span>Exportar FB</span>
                </span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="$router.push({name: 'products-import'})">
                <span class="flex items-center">
                  <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2"/>
                  <span>Actualizar precios</span>
                </span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
          <!-- Add new -->
          <vs-button :disabled="initProgress" color="danger" type="border" class="mr-6" @click="addNewData">
            Agregar
          </vs-button>
        </div>

        <!-- Items per page -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{
              currentPage * itemsPerPage - (itemsPerPage - 1)
              }} - {{ list.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : list.length }} de {{
              queriedItems
              }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
          </div>
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage = 10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 20">
              <span>20</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 30">
              <span>30</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 40">
              <span>40</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="sku">SKU</vs-th>
        <vs-th sort-key="name">Nombre</vs-th>
        <vs-th sort-key="slug">Color</vs-th>
        <vs-th sort-key="category">Categoría</vs-th>
        <vs-th sort-key="stock">Stock</vs-th>
        <vs-th sort-key="normalPrice">Precio Normal</vs-th>
        <vs-th sort-key="priceDiscount">Precio Dcto.</vs-th>
        <vs-th sort-key="priceDiscount">Fin de promoción.</vs-th>
        <vs-th>Estado</vs-th>
        <vs-th>Acciones</vs-th>
      </template>

      <template slot-scope=" {data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.sku }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.name }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.color ? tr.color.name : 'NA' }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.category ? tr.category.name : 'NN' }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.stock }}
                <span
                  v-if="tr.state && (tr.stock === undefined || tr.stock <= 0)"
                  class="ml-1 px-2 py-px rounded text-white text-xs"
                  style="background:#dc2626;">AGOTADO</span>
              </p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.normalPrice }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.priceDiscount }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.endDate | date }}</p>
            </vs-td>

            <vs-td>
              <vs-switch @input="switchState(tr)" v-model="tr.state"/>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                            @click.stop="editData(tr)"/>
              <feather-icon class="ml-2" icon="EyeIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                            @click.stop="viewProduct(tr)"/>
              <feather-icon class="ml-2" icon="ScissorsIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                            @click.stop="addSize(tr)"/>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import New from './New'
import Update from './Update'
import Sizes from './Sizes'
import vSelect from 'vue-select'

import { db } from '@/firebase/firebaseConfig'

export default {
  name: 'ListProducts',
  components: {
    New,
    Update,
    vSelect,
    Sizes
  },
  data() {
    return {
      itemsPerPage: 20,
      isMounted: false,
      list: [],
      productsAll: [],
      listForRelatedProducts: [],
      initProgress: false,
      selected: null,
      filter: false,
      //Filters
      categories: [],
      colors: [],
      stocksOptions: [
        { label: 'Todos', value: -1 },
        { label: 'Sin stock', value: 0 },
        { label: 'Por acabarse', value: 10 },
      ],
      categoryFilter: {
        label: 'Todos',
        value: -1
      },
      stockFilter: {
        label: 'Todos',
        value: -1
      },
      //

      // Data Sidebar
      newSidebar: false,
      updateSidebar: false,
      sizeSidebar: false,
      sidebarData: {},
      // Export
      fileName: '',
      formats: ['xlsx', 'csv', 'txt'],
      cellAutoWidth: true,
      selectedFormat: 'xlsx',
      headerTitle: ['ID', 'Nombre', 'Color', 'SKU', 'Stock', 'Precio normal', 'Precio con descuento', 'Colección', 'Estado'],
      headerVal: ['id', 'name', 'color', 'sku', 'stock', 'normalPrice', 'priceDiscount', 'collection', 'state'],
      activePrompt: false
    }
  },
  async created() {
    try {
      this.initProgress = true
      await this.loadProducts()
      await this.loadCategories()
      await this.loadColors()
      this.initProgress = false
    } catch (e) {
      console.log(e)
      this.$vs.notify({
        color: 'warning',
        title: '¡Oh no!',
        text: 'Hubo un error.'
      })
    } finally {
      this.initProgress = false
    }
  },
  mounted() {
    this.isMounted = true
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems() {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.list.length
    }
  },
  watch: {
    /**
     * Filter by category
     * @param val
     * @returns {Promise<void>}
     */
    async categoryFilter(val) {
      try {
        if (val.value !== -1) {
          this.initProgress = true
          this.list = []
          const querySnapshot = await db.collection('products')
            .where('category.id', '==', this.categoryFilter.id)
            .orderBy('createdAt', 'desc').get()

          querySnapshot.forEach((doc) => {
            let product = {
              id: doc.id,
              ...doc.data()
            }
            this.list.push(product)
          })
        }
      } catch (e) {
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'Hubo un error.'
        })
      } finally {
        this.initProgress = false
      }
    },
    /**
     * Filter by stock
     * @param val
     * @returns {Promise<void>}
     */
    async stockFilter(val) {
      try {
        if (val.value !== -1) {
          this.initProgress = true
          this.list = []
          const querySnapshot = await db.collection('products')
            .where('stock', '<=', this.stockFilter.value).get()

          querySnapshot.forEach((doc) => {
            let product = {
              id: doc.id,
              ...doc.data()
            }
            this.list.push(product)
          })
        }
      } catch (e) {
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'Hubo un error.'
        })
      } finally {
        this.initProgress = false
      }
    }
  },
  methods: {
    addNewData() {
      this.sidebarData = {}
      this.newSidebar = true
    },
    editData(data) {
      if (data) {
        this.sidebarData = data
        this.toggleUpdateSidebar(true)
      }
    },
    addSize(data) {
      if (data) {
        this.sidebarData = data
        this.toggleSizeSidebar(true)
      }
    },
    filterData() {
      this.filter = !this.filter
    },
    toggleNewSidebar(val = false) {
      this.newSidebar = val
    },
    toggleUpdateSidebar(val = false) {
      this.updateSidebar = val
    },
    toggleSizeSidebar(val = false) {
      this.sizeSidebar = val
    },
    /**
     * Enable or disabled
     * @param product
     */
    async switchState(product) {
      try {
        let productRef = await db.collection('products').doc(product.id)
        productRef.update({
          state: product.state
        })
        this.$vs.notify({
          color: 'success',
          title: 'Producto',
          text: 'La modificación fue aplicada.'
        })
      } catch (e) {
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'Hubo un error.'
        })
      }
    },
    /**
     * Get products of firestore
     * @returns {Promise<void>}
     */
    async loadProducts() {
      const querySnapshot = await db.collection('products').orderBy('createdAt', 'desc').get()
      querySnapshot.forEach((doc) => {
        let product = {
          id: doc.id,
          ...doc.data(),
          order: doc.data().order ? doc.data().order : 0,
          endDate: doc.data().endDate ? doc.data().endDate.toDate() : null,
          newProduct: doc.data().newProduct
        }
        if (product.newProduct === undefined) {
          product.newProduct = false
        }
        this.list.push(product)
        // Validate if product is variant
        if (product.isVariant === 'false') {
          let productAll = {
            id: product.id,
            label: product.name + ' - ' + product.sku
          }
          this.productsAll.push(productAll)
        }
      })
    },
    /**
     * Get categories of firestore
     * @returns {Promise<void>}
     */
    async loadCategories() {
      const querySnapshot = await db.collection('categories').orderBy('createdAt', 'desc').get()
      querySnapshot.forEach((doc) => {
        let category = {
          id: doc.id,
          name: doc.data().name,
          slug: doc.data().slug
        }
        this.categories.push(category)
      })
    },
    /**
     * Get colors of firestore
     * @returns {Promise<void>}
     */
    async loadColors() {
      const querySnapShot = await db.collection('colors').orderBy('createdAt', 'desc').get()
      querySnapShot.forEach((doc) => {
        let color = {
          id: doc.id,
          name: doc.data().name,
          hex: doc.data().hex
        }
        this.colors.push(color)
      })
    },
    /**
     * Reset filters
     * @returns {Promise<void>}
     */
    async resetFilters() {
      try {
        this.initProgress = true
        await this.loadProducts()

        this.categoryFilter = {
          label: 'Todos',
          value: -1
        }
        this.stockFilter = {
          label: 'Todos',
          value: -1
        }
        this.$refs.filterCard.removeRefreshAnimation()
      } catch (e) {
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'Hubo un error.'
        })
      } finally {
        this.initProgress = false
      }
    },
    /**
     * Export to excel
     */
    exportToExcel() {
      import('@/vendor/Export2Excel').then(excel => {
        const list = []
        this.list.forEach((p) => {
          if(p.state) {
            let product = {
              id: p.id,
              name: p.name + '-' + p.color.name,
              sku: p.sku,
              stock: p.stock,
              priceDiscount: p.campaignPrice + '',
              normalPrice: p.normalPrice + '',
              state: p.state,
              color: p.color.name,
              collection: p.collection.label
            }
            list.push(product)
          }
        })
        const data = this.formatJson(this.headerVal, list)
        excel.export_json_to_excel({
          header: this.headerTitle,
          data,
          filename: this.fileName,
          autoWidth: this.cellAutoWidth,
          bookType: this.selectedFormat
        })
        this.clearFields()
      })
    },
    /**
     * Export excel to fb
     */
    exportToExcelFB() {
      import('@/vendor/Export2Excel').then(async excel => {
        this.initProgress = true
        const list = []
        for await (let p of this.list) {
          const querySnapshot = await db.collection('products').doc(p.id).collection('sizes').get()
          if (querySnapshot.size !== 0) {
            querySnapshot.forEach((doc) => {
              if (p.collection && p.state) {
                let product = {
                  id: p.sku + '-' + doc.data().size,
                  title: p.name + ' - ' + p.color.name,
                  description: p.description,
                  availability: doc.data().stock > 0 ? 'in stock' : 'out of stock',
                  condition: 'new',
                  price: p.normalPrice + ' PEN',
                  link: 'https://chronicles.club/products/' + p.collection.slug + '/' + p.slug,
                  image_link: p.image1,
                  additional_image_link: p.image1,
                  brand: 'Chronicles',
                  sale_price: p.priceDiscount + ' PEN',
                  visibility: p.state ? 'visibility' : 'hidden',
                  color: p.color.name,
                  size: doc.data().size,
                  item_group_id: p.sku
                }
                list.push(product)
              }
            })
          }
        }
        const headerVal = ['id', 'title', 'description', 'availability', 'condition', 'price', 'link', 'image_link', 'brand', 'sale_price', 'visibility', 'additional_image_link', 'color', 'size', 'item_group_id']
        const headerTitle = ['id', 'title', 'description', 'availability', 'condition', 'price', 'link', 'image_link', 'brand', 'sale_price', 'visibility', 'additional_image_link', 'color', 'size', 'item_group_id']
        const data = this.formatJson(headerVal, list)
        excel.export_json_to_excel({
          header: headerTitle,
          data,
          filename: 'Exportacion para FB',
          autoWidth: this.cellAutoWidth,
          bookType: this.selectedFormat
        })
        this.clearFields()
        this.initProgress = false
      })
    },
    clearFields() {
      this.filename = ''
      this.cellAutoWidth = true
      this.selectedFormat = 'xlsx'
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        // Add col name which needs to be translated
        // if (j === 'timestamp') {
        //   return parseTime(v[j])
        // } else {
        //   return v[j]
        // }

        return v[j]
      }))
    },
    viewProduct(product) {
      console.log(product)
      window.open(
        'https://chronicles.club/products/' + product.collection.slug + '/' + product.slug,
        '_blank'
      )
    },
    /**
     * Slug
     * @param name
     * @returns {string}
     */
    getSlug(name) {
      let text = (name).trim().split(' ').join('-').toLowerCase().normalize('NFD')
        .replace(/([aeio])\u0301|(u)[\u0301\u0308]/gi, '$1$2')
        .normalize()
      return text
    },
    /**
     * Add data of sidebar
     * */
    addDataSideBar(o) {
      this.list.unshift(o)
    },
    /**
     * Update data of sidebar
     * */
    updateDataSideBar(o) {
      const index = this.list.findIndex((d) => d.id === o.id)
      Object.assign(this.list[index], o)
    }
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: .5rem;
            border-bottom-left-radius: .5rem;
          }

          &:last-child {
            border-top-right-radius: .5rem;
            border-bottom-right-radius: .5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
